import { jsx } from '@emotion/core';
import { default as AutosizeTextArea } from 'react-textarea-autosize';
import { COLORS, BORDER_RADIUS } from '../../constants';
import { ErrorField } from '../shared';
import { Label } from './label';
import { Wrapper } from './wrapper';
var textAreaStyles = {
  display: 'block',
  width: '100%',
  borderRadius: BORDER_RADIUS.medium,
  color: COLORS.grays.darkest,
  padding: 10,
  resize: 'vertical',
  margin: 0,
  border: "solid 1px " + COLORS.grays.lighter,
  boxShadow: 'inset 0 1px 3px 0 rgba(0, 0, 0, 0.13)',
  '&:hover': {
    boxShadow: '0 0 4px rgba(0, 0, 0, 0.3)'
  },
  '&:focus': {
    border: 'solid 1px #a2d3ff',
    outline: '#a2d3ff',
    boxShadow: '0 0 5px #a2d3ff'
  },
  '&:disabled': {
    background: COLORS.grays["super"],
    border: "solid 1px " + COLORS.grays.lighter,
    color: COLORS.grays.gray,
    cursor: 'not-allowed'
  }
};
var invalidTextAreaStyles = {
  border: "solid 1px " + COLORS.spot.critical,
  borderBottomLeftRadius: 0,
  borderBottomRightRadius: 0,
  boxShadow: 'inset 0 1px 3px 0 rgba(252,76,93,0.40)',
  '&:hover': {
    boxShadow: '0 0 4px rgba(252, 76, 93, 0.6)'
  }
};
var textAreaWithLabelStyles = {
  margin: '4px 0 0 0'
};

var dynamicStyles = function dynamicStyles(defaultHeight) {
  return {
    minHeight: defaultHeight
  };
};

export var TextArea = function TextArea(_a) {
  var errorMessage = _a.errorMessage,
      label = _a.label,
      _b = _a.defaultHeight,
      defaultHeight = _b === void 0 ? 50 : _b,
      className = _a.className,
      value = _a.value,
      placeholder = _a.placeholder,
      id = _a.id,
      _c = _a.onChange,
      onChange = _c === void 0 ? function () {} : _c,
      disabled = _a.disabled,
      autoFocus = _a.autoFocus;
  var isValid = !errorMessage;
  var styles = [textAreaStyles, dynamicStyles(defaultHeight)];
  if (!isValid) styles.push(invalidTextAreaStyles);
  if (label) styles.push(textAreaWithLabelStyles);
  return jsx(Label, {
    isValid: isValid,
    className: className
  }, label, jsx(Wrapper, null, jsx(AutosizeTextArea, {
    css: styles,
    value: value,
    placeholder: placeholder,
    id: id,
    onChange: onChange,
    disabled: disabled,
    autoFocus: autoFocus
  })), !isValid && jsx(ErrorField, null, errorMessage));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Input/textarea.js
// module id = 953
// module chunks = 0